module.exports = __webpack_public_path__ + "img/accident-icon.25150552.png";